RFM_APP.controller("manualInfoController", ["$rootScope", "$scope", "$http", "$timeout", "$location", "helper", "$state", "$compile", "requestMilesService", "$window",  function ($rootScope, $scope, $http, $timeout, $location, helper, $state, $compile, requestMilesService, $window) {
	RFM_APP.requestMiles.initAirportLookup('.aaAirportLookup');
    helper.updatePageTitle("pageTitle_manual_rfm");
     var formData = requestMilesService.getFormData();
     $scope.form = {};
     $scope.form.requestMilesInfoSortedlabels = ["aadvantageNumber", "eticketNumber"];
     $scope.form.passengerInfoSortedlabels = ["firstName", "lastName"];
     $scope.form.flightInfoSortedlabels = ["airlineFlown", "flightNumber", "flightDate", "flightOrigin", "flightDestination"];
     $scope.form.contactInfoSortedlabels = ["primaryPhone", "email","confirmEmail"];
     $scope.form.labels = requestMilesService.getLabels();
     if(formData != null && formData.landingPayload != null){
         $scope.form.requestMilesInfo = formData.landingPayload.requestMilesInfo;
         if($scope.form.requestMilesInfo.jetSmartFlag){
             $scope.form.requestMilesInfo.eticketNumber = '0011111111111';
             $j("#eticketNumberDiv").hide();
         }
     } else {
         $scope.form.requestMilesInfo = {};
         $state.go('request');
     }

     $scope.form.flightInfoList = [];
     if(formData != null) {
         $scope.form.passengerInfo = formData.passengerDetails;
     }
     if($scope.form.passengerInfo == null || $scope.form.passengerInfo.contactInfo == null || $scope.form.passengerInfo.contactInfo.confirmEmail == null){
         $scope.showConfEmail = true;
         if($scope.form.passengerInfo != null && $scope.form.passengerInfo.contactInfo != null) {
             $scope.form.passengerInfo.contactInfo.confirmEmail = "";
         }
     } else {
         $scope.showConfEmail = false;
     }

     $scope.backToSearch = function(){
         requestMilesService.clearPageErrorCodes();
         $state.go('request');
     }

     $scope.doFocus = function(attr) {
         console.log(attr);
         $timeout(function () {
             angular.element('#' + attr).focus();
         },0);
     }
     function addFlight() {
         if( $scope.form.flightInfoList === undefined){
             $scope.form.flightInfoList = [];
         }
         $scope.form.flightInfoList.push({});
     };
     $scope.addFlight = addFlight;
     $scope.removeFlight = function (idx) {
         $scope.form.flightInfoList.splice(idx, 1);
         $timeout(function () {
             $j("#addFlight").focus();
         },0);
     };
     $scope.showConfirmEmail = function () {
         if($scope.showConfEmail != true){
             $j("#ariaLiveReaderContainer").html("Email has been changed, please Confirm Email.");
             $scope.form.passengerInfo.contactInfo.confirmEmail="";
         }
         $scope.showConfEmail = true;
     };
     $scope.isNumber = function (event) {
         helper.isNumber(event);
     };
     $scope.getClass = function (index) {
         if(index == 0 || index == 3) {
        	 return "row-form";
         }
         return "";
     };

     $scope.populateSummary = function(){
         $j(".needRefresh").trigger("change");
         requestMilesService.populateSummary($scope.form).then(
             function(response){
                 if(typeof response.data.errorSummaryMessage !== 'undefined'){
                     // show error message
                     $scope.form.errors = response.data;
                     $scope.form.errorKeys = requestMilesService.doSorting(response.data.requestMilesInfo, $scope.form.requestMilesInfoSortedlabels);
                     $scope.form.errorKeys = $scope.form.errorKeys.concat(requestMilesService.doSorting(response.data.passengerInfo, $scope.form.passengerInfoSortedlabels));
                     $scope.form.errorKeys = $scope.form.errorKeys.concat(requestMilesService.doListSorting(response.data.flightInfoList, $scope.form.flightInfoSortedlabels));
                     if(response.data.requestMilesInfo != undefined && response.data.requestMilesInfo.aadvantageNumberCode != undefined && response.data.requestMilesInfo.aadvantageNumberCode === 'ERRCODE1429') {
 	                    response.data.requestMilesInfo.aadvantageNumber = '';
                     } else if (response.data.passengerInfo != undefined){
                         $scope.form.errorKeys = $scope.form.errorKeys.concat(requestMilesService.doSorting(response.data.passengerInfo.contactInfo, $scope.form.contactInfoSortedlabels));
                     }
                     $timeout(function() {
                         helper.scrollToErrorSummary($j("#errorSummary"));
                     }, 0);
                     requestMilesService.addToWebAnalytics("page_name", "Request Flight Miles-Enter Details");
                     requestMilesService.addToWebAnalytics("error_id", requestMilesService.getPageErrorCodes());
                     requestMilesService.reportToWebAnalytics();
                 }else{
                     requestMilesService.clearPageErrorCodes();
                     $state.go('review-and-submit');
                 }
             },function(error){
                 helper.errorHandler(error, $errorMessage, errorPage);
             });
      }
     var summary = requestMilesService.getSummary();
     if(summary == null || summary.payLoad == null || summary.payLoad.flightInfoList == null) {
         addFlight();
     } else {
         $scope.form.flightInfoList = summary.payLoad.flightInfoList;
     }
     $timeout(function () {
         aaPhoneCountryCode.initSelectBox();
         aaPhoneCountryCode.initLabelBox();
         $timeout(function() {
             $j("#countryCodePrimary").trigger("change");
         }, 1);
         $timeout(function() {
             helper.scrollToErrorSummary($j("#infoMessageSummary"));
         }, 0);
     },1);
     requestMilesService.addToWebAnalytics("page_name", "Request Flight Miles-Enter Details");
     requestMilesService.overrideSkipLinks();
}]);
